import type { UseFormRegister, UseFormWatch } from "react-hook-form";
import { MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, Switch } from "@/components/ui";
import { SectionCard } from "@/components/common";
import { ActivityCategory } from "@/types";
import type { ActivityDetailFormValues } from "../activityDetailForm";

interface HandshakeConfigSectionProps {
  activityCategory: ActivityCategory;
  register: UseFormRegister<ActivityDetailFormValues>;
  watch: UseFormWatch<ActivityDetailFormValues>;
  modified: boolean;
}

export function HandshakeConfigSection({
  activityCategory,
  register,
  watch,
  modified,
}: HandshakeConfigSectionProps) {
  const { t } = useTranslation("activities");
  const requiresHandshake = watch("requires_handshake");

  const enabledNoteKey =
    activityCategory === ActivityCategory.RESTAURANT
      ? "detailForm.handshakeNoteRestaurant"
      : "detailForm.handshakeNote";

  return (
    <SectionCard
      title={t("detailForm.handshakeConfigTitle")}
      icon={MessageSquare}
      modified={modified}
    >
      <Switch
        {...register("requires_handshake")}
        label={t("detailForm.requiresHandshake")}
        description={t("detailForm.requiresHandshakeHint")}
      />
      {requiresHandshake ? (
        <Alert
          variant="warning"
          className="rounded-lg p-3"
        >
          <strong>{t("detailForm.noteStrong")}</strong> {t(enabledNoteKey)}
        </Alert>
      ) : null}
    </SectionCard>
  );
}
